document.addEventListener('DOMContentLoaded', () => {
	const slides = document.querySelectorAll('.fv-slide');
	if (slides.length < 2) return;
	if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

	const fvImage = document.querySelector('.fv-image');
	if (!fvImage) return;

	let current = 0;
	let timerId = null;

	const tick = () => {
		slides[current].classList.remove('is-active');
		current = (current + 1) % slides.length;
		slides[current].classList.add('is-active');
	};
	const start = () => {
		if (timerId) return;
		timerId = setInterval(tick, 5000);
	};
	const stop = () => {
		clearInterval(timerId);
		timerId = null;
	};

	const observer = new IntersectionObserver(([entry]) => {
		if (entry.isIntersecting) {
			start();
		} else {
			stop();
		}
	});
	observer.observe(fvImage);
});
